<template>
  <v-app>
    <v-main>
      <template v-if="application">
        <map-wrapper v-if="!configureError" />
        <v-img v-else-if="params('draft') === 'true'">
          <v-container class="px-5">
            <v-col class="text-center px-5 mb-5">
              <v-alert
                :value="true"
                type="warning"
                outlined
              >
                <h3>{{ configureError }}</h3>
              </v-alert>
            </v-col>
          </v-container>
        </v-img>
      </template>
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import MapWrapper from './components/MapWrapper.vue'

export default {
  components: {
    MapWrapper
  },
  computed: {
    ...mapState(['application']),
    ...mapGetters(['datasetUrl', 'config']),
    configureError () {
      if (!this.datasetUrl) return 'Veuillez sélectionner une source de données'
      return null
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      async handler () {
        if (!this.config.datasets) return
        const conceptFilters = {}
        const datasetFiltersPrefix = `_d_${this.config.datasets[0].id}_`
        for (const key in this.$route.query) {
          if (key.startsWith('_c_')) {
            conceptFilters[key] = this.$route.query[key]
          }
          if (key.startsWith(datasetFiltersPrefix)) {
            conceptFilters[key.replace(datasetFiltersPrefix, '')] = this.$route.query[key]
          }
        }
        this.$store.commit('setAny', { conceptFilters })
        if (!this.configureError) this.$store.dispatch('init')
      }
    }
  },
  mounted () {
    window.vIframeOptions = {
      router: this.$router,
      reactiveParams: true
    }
  },
  methods: {
    params (p) {
      const params = new URLSearchParams(window.location.search)
      return params.get(p)
    }
  }
}
</script>

<style>
.v-application {
  font-family: "Nunito", sans-serif!important;
}
</style>
